import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLogin: sessionStorage.getItem("isLogin") ? true : false,
};


export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        updateLoginFlg: (state, action) => {
            sessionStorage.setItem("isLogin",action.payload)
            state.isLogin = action.payload;
        },
        removeLoginFlg: (state) => {
            sessionStorage.removeItem("isLogin")
            state.isLogin = false;
        }
    },
});

export const { updateLoginFlg, removeLoginFlg } = loginSlice.actions;
export default loginSlice.reducer;
